export const USER_MANUAL = {
    HOME_PAGE : "homePage",
    SIGN_IN : "signIn",
    PRODUCT_PAGE : "productPage",
    API_CARD_SECTION : "apiCardSection",
    ACCOUNT_AUTHORIZATION : "accountAuthorization",
    USING_OTHER_API : "usingOtherApi",
    USER_PROFILE_PAGE : "userProfilePage",
    SIGN_OUT : "signOut",
    FORGOT_PASSWORD : "forgotPassword",
    POINT_TO_REMEMBER : "pointToRemember",
    ACTIVE : "active"
}